module.exports = __webpack_public_path__ + "static/media/Energie-Scouts_800x500.4465d5a0.jpg";